import React from "react";

export const Strike = ({ strikeClass }) => {
  return <div className={`strike ${strikeClass}`}></div>;
};
